import React, { FC, Fragment } from 'react';
import { FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useQuery } from '@apollo/client';
import { getCategoriesTemplate } from 'apollo/templates/action';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { useTranslation } from 'react-i18next';
import Loader from 'components/shared/loader/loader.component';

type CategoryFilterDropdownProps = {
    category: string;
    onCategorySelect: (category: string) => void;
};
const CategoryFilterDropdown: FC<CategoryFilterDropdownProps> = ({
    category,
    onCategorySelect,
}: CategoryFilterDropdownProps) => {
    const { t: translate } = useTranslation('orders');
    const { showBoundary } = useDenthubErrorBoundary();

    const { data: { categories } = {}, loading: categoriesLoading } = useQuery(getCategoriesTemplate, {
        notifyOnNetworkStatusChange: true,
        onError(error) {
            showBoundary(error);
        },
    });

    return (
        <Fragment>
            {categoriesLoading ? (
                <Loader />
            ) : (
                <FormControl margin="dense" fullWidth style={{ minWidth: 150 }}>
                    <InputLabel>{translate('orders:CATEGORY')}</InputLabel>
                    <Select
                        label={translate('orders:CATEGORY')}
                        value={category}
                        onChange={(event: SelectChangeEvent<string>) => onCategorySelect(event.target.value)}
                        endAdornment={
                            <Fragment>
                                {category !== '' && (
                                    <IconButton
                                        size="small"
                                        sx={{
                                            marginRight: '.75rem',
                                        }}
                                        onClick={() => onCategorySelect('')}
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                )}
                            </Fragment>
                        }
                    >
                        {categories.map((category: { _id: string; name: string }) => (
                            <MenuItem key={category._id} value={category.name}>
                                {category.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Fragment>
    );
};

export default CategoryFilterDropdown;
